<template>
  <v-avatar size="25" tile>
    <img :src="avatarUrl" alt="Player avatar" />
  </v-avatar>
</template>
<script>
import config from "@/config.js";

export default {
  props: {
    username: {
      type: String,
      default: "unknown"
    }
  },
  computed: {
    avatarUrl() {
      return `${config.minotarUrl}/${this.username}/25`;
    }
  }
};
</script>
<style lang="sass"></style>
